<template>
	<tab_header icon="fa-solid fa-signal" title="Transmissões" />

	<div class="row">
		<div class="col-12">
			<transmition_test_card
				ref="webcam_transmition_component"
				device="Webcam"
				title="Teste de transmissão da webcam"
				icon="uil uil-webcam"
				:enrollment_test_id="props.enrollment_test_id"
				:computer_uid="props.computer_uid"
				:commands_urls="webcam_commands_urls"
                :streaming_details="{
                    streaming_url: props.webcam_webrtc_streaming_source,
                    width: 500,
                    height: 500
                }"
                :streaming_already_started="props.webcam_already_started"
                :commands_enabled="props.webcam_commands_enabled"
                :streaming_auth_credential="props.streaming_auth_credential">
            </transmition_test_card>
		</div>
		<div class="col-12">
			<transmition_test_card
				device="Tela"
				title="Teste de transmissão da tela"
				icon="uil uil-monitor"
				:enrollment_test_id="props.enrollment_test_id"
				:computer_uid="props.computer_uid"
				:commands_urls="screen_commands_urls"
                :streaming_details="{
                    streaming_url: props.screen_webrtc_streaming_source,
                    width: 800,
                    height: 600
                }"
                :streaming_already_started="props.screen_already_started"
                :commands_enabled="true"
                :streaming_auth_credential="props.streaming_auth_credential">
            </transmition_test_card>
		</div>
		<div class="col-12">
			<div class="card shadow-sm border p-5">
				<div class="d-flex align-items-center">
					<i class="uil uil-monitor" style="font-size: 30px"></i>
					<h4 class="text-uppercase m-0">
						Circuito fechado de câmeras
					</h4>
				</div>

				<div class="row btn-group p-2 mt-2" role="group">
					<a
						:href="props.dvrs_page_url"
						target="_blank"
						id="dvrs-page-link"
						class="col-12 col-md-4 btn-ws btn-lg btn-block btn mt-2 btn-success">
						Visualizar
					</a>
					<button
						@click="restartDvrs()"
						id="restart-dvrs"
						class="col-12 col-md-4 btn-ws-action btn-lg btn-block btn mt-2 btn-primary">
						Reiniciar todas as câmeras
						<i
							class="ml-3 mt-3 mb-4"
							:class="{
								'fa fa-spin fa-spinner': request_restart_dvrs,
								'fas fa-check-circle':
									request_restart_dvrs_successful,
								'fas fa-exclamation-circle ':
									request_restart_dvrs_failed,
							}">
						</i>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import tab_header from './tab_header.vue';
	import transmition_test_card from './transmition_test_card.vue';
	import axios from 'axios';
	import { inject, ref } from 'vue';

	const props = defineProps({
		computer_uid: { type: String, required: true },
		enrollment_test_id: { type: String, required: true },
		devices_commands_urls: { type: Object, required: true },
		dvr_id: { type: Number, required: true },
		dvrs_page_url: { type: String, required: true },
        webcam_webrtc_streaming_source: { type: String, required: true },
        screen_webrtc_streaming_source: { type: String, required: true },
        webcam_already_started: { type: Boolean, required: true },
        screen_already_started: { type: Boolean, required: true },
        webcam_commands_enabled: { type: Boolean, required: true },
        streaming_auth_credential: { type: String, required: true },
    });

	const webcam_transmition_component = ref<InstanceType<
		typeof transmition_test_card
	> | null>(null);

	const emitter = inject('emitter');

	//@ts-ignore
	emitter.on('webcam_options_changed', async () => {
		if (webcam_transmition_component.value?.streaming_on) {
			//@ts-ignore
			toastr.success(
				'Reiniciando webcam para utilizar novas configurações'
			);

			await webcam_transmition_component.value?.stopTransmition();

			setTimeout(async () => {
				await webcam_transmition_component.value?.startTransmition();
			}, 3000);
		}
	});

	const webcam_commands_urls = {
		start: props.devices_commands_urls.start_webcam,
		stop: props.devices_commands_urls.stop_webcam,
		restart: props.devices_commands_urls.restart_webcam,
	};

	const screen_commands_urls = {
		start: props.devices_commands_urls.start_screen,
		stop: props.devices_commands_urls.stop_screen,
		restart: props.devices_commands_urls.restart_screen,
	};

	const request_restart_dvrs = ref(false);
	const request_restart_dvrs_successful = ref(false);
	const request_restart_dvrs_failed = ref(false);

	function restartDvrs() {
		request_restart_dvrs.value = true;
		request_restart_dvrs_successful.value = false;
		request_restart_dvrs_failed.value = false;
		axios
			.get(props.devices_commands_urls.restart_dvrs, {
				params: {
					dvr_id: props.dvr_id,
				},
			})
			.then((response) => {
				request_restart_dvrs.value = false;
				request_restart_dvrs_successful.value = true;
			})
			.catch((response) => {
				request_restart_dvrs.value = false;
				request_restart_dvrs_failed.value = true;
			});
	}
</script>
